// @givmo/board — the house form for an organization's name (CBG-FIX143; CBG-UX-COPY2's fold, P1).
//
// Board's words set the organization's name after an article, "the {organization} board", so a
// name ending in "s" never reads "…Arts’s board". A name that begins with its own "The" ("The Arc of
// Harbor County") would then read "the The Arc of Harbor County board", so the house form drops it:
// the sentence's article stands for the name's, as CBG-FIX97 kept a committee's name from meeting an
// article. The backend's mails do the same (`organization_house_form.house_form_name`, the mails'
// `house_form` filter), so a mail's preview here reads as the mail is sent.

/**
 * The organization's name as the house form sets it after an article: "The Arc of Harbor County"
 * reads "Arc of Harbor County"; any other name, and a name that is only "The", stays as it is
 * (trimmed).
 */
export function houseFormName(organization: string): string {
  const name = organization.trim();
  return name.replace(/^the\s+/i, '') || name;
}
